import { type VariantProps, cva, cx } from "cva";
import type { ComponentProps, FunctionComponent } from "react";

const spinnerRecipe = cva({
  base: "kn-spinner",
  variants: {
    color: {
      primary: "kn-spinner-primary",
      secondary: "kn-spinner-secondary",
      tertiary: "kn-spinner-tertiary",
      white: "kn-spinner-white",
    },
    size: {
      extraSmall: "kn-spinner-extra-small",
      small: "kn-spinner-small",
      medium: "kn-spinner-medium",
      large: "kn-spinner-large",
      extraLarge: "kn-spinner-extra-large",
    },
  },
  defaultVariants: {
    color: "primary",
    size: "medium",
  },
});

type SpinnerRecipeVariants = VariantProps<typeof spinnerRecipe>;

export type SpinnerProps = {} & SpinnerRecipeVariants &
  Omit<ComponentProps<"div">, keyof SpinnerRecipeVariants>;

const Spinner: FunctionComponent<SpinnerProps> = ({
  className,
  color = "primary",
  size = "medium",
  ...restProps
}) => {
  return <div className={cx(spinnerRecipe({ color, size }), className)} {...restProps} />;
};

Spinner.displayName = "Spinner";

export default Spinner;
